import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import kebabCase from 'lodash/kebabCase.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoCard from '../../components/card/pendo-card.vue.js';
import PendoChooserGrid from '../../components/chooser-grid/pendo-chooser-grid.vue.js';
import PendoLayoutPreview from './pendo-layout-preview.vue.js';
import PendoModal from '../../components/modal/pendo-modal.vue.js';
import PendoTag from '../../components/tag/pendo-tag.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';
import PendoPopover from '../../components/popover/pendo-popover.vue.js';
import PendoCollapse from '../../components/collapse/pendo-collapse.vue.js';
import PendoCollapseItem from '../../components/collapse/pendo-collapse-item.vue.js';

var script = {
  name: 'PendoLayoutGrid',
  components: {
    PendoCollapse,
    PendoCollapseItem,
    PendoCard,
    PendoChooserGrid,
    PendoLayoutPreview,
    PendoButton,
    PendoModal,
    PendoTag,
    PendoPopover
  },
  directives: {
    PendoTooltip
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: null
    },
    layouts: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    allowActions: {
      type: Object,
      default: () => ({})
    },
    filters: {
      type: [Object, Array],
      default: () => [{
        prop: ['title', 'subtitle'],
        value: ''
      }]
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activePanels: [],
      showDeleteLayoutModal: false,
      layoutToDelete: null,
      selectedLayout: null
    };
  },
  computed: {
    formattedLayouts() {
      const {
        loading,
        layouts,
        disabled,
        selectedLayout
      } = this;
      if (loading && !layouts.length) {
        return [{
          name: 'layouts',
          title: 'Layouts',
          children: Array(8).fill({
            disabled: true,
            loading: true
          })
        }];
      }
      return layouts.map(layoutGroup => {
        const {
          title,
          children
        } = layoutGroup;
        return _objectSpread2(_objectSpread2({}, layoutGroup), {}, {
          dataCy: kebabCase(`${title} Layouts`),
          title: `${title} Layouts (${children.length})`,
          children: children.map(layout => {
            const id = layout.id || kebabCase(layout.name);
            return _objectSpread2(_objectSpread2({}, layout), {}, {
              id,
              title: layout.name,
              subtitle: layout.subtext || 'Pendo Default',
              disabled: loading || layout.loading || disabled || !layout.active,
              loading: loading || layout.loading,
              selected: selectedLayout ? selectedLayout.id === id : false,
              tooltipOptions: _objectSpread2(_objectSpread2({}, layout.tooltipOptions), {}, {
                content: layout.active ? null : layout.tooltipOptions && layout.tooltipOptions.content
              })
            });
          })
        });
      });
    }
  },
  watch: {
    formattedLayouts: {
      handler(newLayouts) {
        this.activePanels = newLayouts.reduce((acc, _ref) => {
          let {
            name,
            children
          } = _ref;
          if (children?.length > 0) {
            acc.push(name);
          }
          return acc;
        }, []);
      },
      immediate: true
    }
  },
  methods: {
    handleLayoutSelect(layout) {
      this.selectedLayout = layout;
      this.$emit('select-layout', layout);
      this.$emit('onChooseLayout', layout);
    },
    handleLayoutDelete(layout) {
      this.layoutToDelete = layout;
      this.showDeleteLayoutModal = true;
    },
    cancelDelete() {
      this.layoutToDelete = null;
      this.showDeleteLayoutModal = false;
    },
    confirmDelete() {
      this.$emit('delete-layout', this.layoutToDelete);
      this.$emit('onDeleteLayout', this.layoutToDelete);
      this.layoutToDelete = null;
      this.showDeleteLayoutModal = false;
    },
    getBeforeLayoutsSlotName(_ref2) {
      let {
        name
      } = _ref2;
      switch (name) {
        case 'org-layouts':
          return 'beforeOrganizationLayouts';
        case 'custom-layouts':
          if (this.$slots.empty) {
            return 'empty';
          }
          return 'beforeCustomLayouts';
        case 'default-layouts':
          return 'beforeLayouts';
        default:
          return null;
      }
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-layout-grid.vue2.js.map
